
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Logo',
  computed: {
    ...mapGetters([
      'global'
    ])
  }
});
